import { useEffect, useState } from "react";
import '../App.css';

import {
    Button, Card,
    CardHeader,
    CardBody,
    CardFooter,
    Typography,
} from "@material-tailwind/react"


function HouseDescription({ findHouse, isMinting, mint }) {

    const [house, setHouse] = useState(null);

    useEffect(() => {
        const h = findHouse();

        async function getHouse() {
            const response = await fetch(h[0]);
            const data = await response.json();
            setHouse(data);
        }
        getHouse();


    }, []);
    return (<>
        {
            house ? <Card className="w-96" color='blue-gray'>

                <CardHeader color="transparent" className="h-96">
                    <img
                        src={'https://gateway.ipfs.io/ipfs' + house.image.slice(29)}
                        alt={house.name}
                        className="h-full w-full"
                    />
                </CardHeader>
                <CardBody className="text-center">
                    <Typography variant="h5" className="mb-2">
                        {house.name}
                    </Typography>
                    <Typography>
                        {house.description}
                    </Typography>
                </CardBody>
                <CardFooter divider className="flex items-center justify-between py-3">
                    <Button fullWidth disabled={!house} onClick={mint} className="bg-indigo-500 shadow-lg shadow-indigo-500/50">
                        {isMinting ? <div class="flex justify-center items-center">
                            <div class=" flex justify-center items-center">
                                <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
                            </div>
                        </div> : "Mint"}
                    </Button>
                </CardFooter>
            </Card> :
                <div class=" flex justify-center items-center">
                    <div class="animate-spin rounded-full h-32 w-32 border-b-2 border-white"></div>
                </div>
        }
    </>)

}

export default HouseDescription;